module.exports = __webpack_public_path__ + "img/swords_off.27fdd711.png";